import React from 'react'
import StagesManager from '../components/StagesManager';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import Responsive from '../components/Responsive';


import { nanoid } from 'nanoid';
import DiagramEditor from '../components/views/DiagramEditor';
import BookingView from '../windows/Applets/BookingView';
import FormBuilder from './FormBuilder';
import GanttWindow from './GanttWindow';
import Kanban from './Kanban';
import PageBuilder from './PageBuilder';
import PageBuilderAT from './PageBuilderAT';
import ProductsView from './Applets/ProductsView';
// import QuizPage from '../components/QuizPage';
import SingleProduct from './Applets/SingleProduct';
import ViewVideo from './Applets/database/ViewVideo';
import ViewBlog from './Applets/database/ViewBlog';
import Automation from './Automation/Automation';
import InquiryResults from './Applets/InquiryResults';
import Confirmation from '../components/Confirmation';
import WorkingHours from './Applets/booking/components/WorkingHours';
import FilterEditorModal from '../components/inputs/FilterEditorModal';
import Fields from '../components/inputs/CustomizeFields';
import SortedBy from '../components/inputs/SortedBy';
import GroupedBy from '../components/inputs/GroupedBy';
import FieldItem from '../components/inputs/FieldItem';
import TasksCalendar from './Desk/Eagleviews/tasksCalendar';
import TestPage from '../components/TestPage';
import WeeklySchedule from '../components/views/weekly/weeklySchedule';
import TreeLook from '../components/TreeLook';
import OpenModalsTest from '../components/OpenModalsTest';
import Schedule from '../components/Schedule';
import Matrix from '../components/views/matrix/Matrix';
import Slider from '../components/slider/Slider';
import YonnectWorld from '../components/views/yonnectWorld/YonnectWorld';
// import Developers from './Developers';
import RichTextEditor from '../components/RichTextEditor';
import EditList from '../components/inputs/EditList';
import ColorInput from '../components/inputs/ColorInput';
import AdminsInput from '../components/inputs/PermissionsInput';
import TimeInput from '../components/inputs/TimeInput';
import DateTimeInput from '../components/inputs/DateTimeInput';
import FormViewer from '../components/FormViewer';
import BoxListView from '../components/views/BoxListView';
import CategoriesScrollView from '../components/views/CategoriesScrollView';
import OrganizationalChart from '../components/OrganizationalChart';
import OrganizationalChartHorizantal from '../components/OrganizationalChartHorizantal';
import Intercommunication from '../components/Intercommunication';
import MultiContentInput from '../components/inputs/MultiContentInput';
import CAPermissions from './CreateApplet/CAPermissions';
import Templates from './Templates';
import LoginWithGoogle from '../components/LoginWithGoogle';

class Test extends React.Component {


    state = {
        tasks: [],
        headers: [
            { key: 'timeinput', type: 'TimeInput', label: 'Time', information: { label: 'Time', seconds: false } }
        ]
    }
    componentDidMount() {

    }

    render() {
        return (
            <div
                className="w-100 d-flex window-content-radius h-100 scroll-no-scrollbar"
            >

                {/* <div className="w-100 d-flex Test back-blur h-100 window-content-radius"  >
                 <div className=' w-100  h-100 bg-white window-content-radius'>
                 <DiagramEditor width={this.props.width} height={this.props.height} /> */}
                {/* <FormBuilder width={this.props.width} height={this.props.height} /> */}

                {/* <MultiContentInput width={this.props.width} /> */}
                {/* <CAPermissions width={this.props.width} /> */}
                {/* <EditList ref={el=>this.editList = el} /> */}
                {/* <ColorInput header={{ key: ('textColor'), information: { default: 'transparent' } }} /> */}
                {/* <OrganizationalChart width={this.props.width} /> */}
                {/* <OrganizationalChartHorizantal width={this.props.width} /> */}
                <LoginWithGoogle width={this.props.width} />
                {/* <RichTextEditor width={this.props.width} /> */}
                {/* <TreeLook /> */}
                {/* <Schedule width={this.props.width} /> */}
                {/* <FilterEditorModal width={this.props.width} header={{ key: 'test' }} /> */}
                {/* <WeeklySchedule/> */}
                {/* <Fields width={this.props.width} /> */}
                {/* <SortedBy width={this.props.width} /> */}
                {/* <Fields width={this.props.width} /> */}
                {/* <SortedBy width={this.props.width} /> */}
                {/* <FieldItem width={this.props.width} /> */}
                {/* <GroupedBy width={this.props.width} /> */}
                {/* <WorkingHours width={this.props.width} /> */}
                {/* <InquiryResults width={this.props.width} /> */}
                {/* <Developers width={this.props.width} /> */}
                {/* <NewAppointment width={this.props.width} /> */}
                {/* <BookingView width={this.props.width} /> */}
                {/* <BookingView width={this.props.width} /> */}
                {/* <Confirmation width={this.props.width} /> */}
                {/* <SingleProducts width={this.props.width} /> */}
                {/* <ProductsView width={this.props.width} /> */}
                {/* <Automation width={this.props.width} /> */}
                {/* <Booking width={this.props.width} /> */}
                {/* <Automation width={this.props.width} /> */}
                {/* <ViewBlog width={this.props.width} /> */}
                {/* <ViewVideo width={this.props.width} /> */}
                {/* <BookingView width={this.props.width}  /> */}
                {/* <DiagramEditor width={this.props.width} /> */}
                {/* <FormBuilder width={this.props.width} /> */}
                {/* <GanttWindow/> */}
                {/* <Kanban/> */}
                {/* <OpenModalsTest width={this.props.width} /> */}
                {/* <PageBuilder width={this.props.width} height={this.props.height} /> */}
                {/* <PageBuilderAT width={this.props.width} /> */}
                {/* <QuizPage width={this.props.width} /> */}
                {/* <TestPage width={this.props.width} /> */}
                {/* <YonnectWorld width={this.props.width} /> */}
                {/* <Templates width={this.props.width} /> */}
                {/* <Matrix width={this.props.width} /> */}
                {/* <AdminsInput user={this.props.user.info} width={this.props.width} /> */}
                {/* <Developers /> */}
                {/* <QuizPage width={this.props.width} data={this.props.data} /> */}
                {/* <FormViewer headers={this.state.headers} ref={el => this.form = el} /> */}
                {/* <TimeInput changeValue={this.setTime} header={{ key: 'time', information: { disabled: true, seconds: true, } }} data={'00:00:00'} /> */}
                {/* <CategoriesScrollView width={this.props.width} type={'text'}/> */}
                {/* <BoxListView width={this.props.width} /> */}
                {/* <Intercommunication width={this.props.width} /> */}

            </div>
        );
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Test);
